import React, {useState} from "react"
import {GroupCelebration} from "@irati/types"
import momentTZ from "moment-timezone"
import RecognitionService from "@irati/recognition/services/Recognition"
import Spacing from "@irati/ui/src/Spacing"
import {injectIntl, InjectIntlProps} from "@irati/utils/lang/injectIntl"
import GenericModal from "@irati/ui/src/GenericModal"
import {H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Scheduler from "../CreateRecognition/Scheduler"

interface Props extends InjectIntlProps {
  show: boolean
  groupCelebration: GroupCelebration
  onClose: () => void
  onDone: () => void
}
const EditGreetingScheduledTimeModal = (props: Props) => {
  const {show, formatMessage, groupCelebration, onClose, onDone} = props
  const [promise, setPromise] = useState<Promise<void>>()
  const [scheduledTime, setScheduledTime] = useState({
    originalTimezone: groupCelebration.originalTimezone,
    scheduledAt: groupCelebration.when
  })

  const editScheduledTime = () => {
    const updatePromise = RecognitionService.updateGroupCelebration({
      groupCelebrationID: groupCelebration.uuid,
      timezone: scheduledTime.originalTimezone,
      scheduledAt: scheduledTime.scheduledAt
    }).then(() => {
      onDone()
    })
    setPromise(updatePromise)
  }
  const onScheduledTimeChange = (scheduledAt: string, originalTimezone: string) => {
    setScheduledTime({
      scheduledAt,
      originalTimezone
    })
  }
  return (
    <GenericModal
      show={show}
      load={promise}
      proceedButtonText={formatMessage({id: "recognition.groupCelebration.changeDatePopup.btn.update"})}
      onConfirm={editScheduledTime}
      onHide={onClose}
      onExited={onClose}>
      <H2>
        <FormattedMessage id="recognition.groupCelebration.changeDatePopup.header" />
      </H2>
      <Spacing marginTop={3} marginBottom={3}>
        <Scheduler
          onChange={onScheduledTimeChange}
          defaultValue={{
            timezone: groupCelebration.originalTimezone,
            date: momentTZ.tz(groupCelebration.when, groupCelebration.originalTimezone)
          }}
          openBelow
          forced
        />
      </Spacing>
    </GenericModal>
  )
}

export default injectIntl(EditGreetingScheduledTimeModal)
